import apiClient from '@/lib/axios'

export const deleteOrganizationById = async (
  organization_id: string
): Promise<User> => {
  const response = await apiClient.delete(`/organizations/${organization_id}`)
  return response.data
}

export const inviteMembers = async (
  params: InviteOrganizationMemberParams
) => {
  const response = await apiClient.post(`/organizations/add-members`, params)
  return response.data
}

export const removeMember = async (
  user_id: string
) => {
  const response = await apiClient.delete(`/organizations/remove-member/${user_id}`)
  return response.data
}

export const createOrganization = async (
  params: CreateOrganizationParams | FormData
): Promise<CreateOrganizationResponse> => {
  const response = await apiClient.post(`/organizations`, params, {
    headers: params instanceof FormData ? {
      'Content-Type': 'multipart/form-data',
    } : undefined,
  })
  return response.data
}

export const updateOrganization = async (
  logoFile?: File,
  organizationName?: string
): Promise<OrganizationDetails> => {
  const formData = new FormData()
  if (logoFile) {
    formData.append('organization_logo', logoFile)
  }
  if (organizationName) {
    formData.append('organization_name', organizationName)
  }
  
  const response = await apiClient.patch(`/organizations`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

export const acceptOrganizationInvite = async (
  params: AcceptOrganizationInviteParams
) => {
  const response = await apiClient.post(`/organizations/accept-invite/${params.organization_id}`)
  return response.data
}

export const getOrganizationUsageInfo = async (
): Promise<GetOrganizationUsageInfoResponse> => {
    const response = await apiClient.get(`/organizations/usage`)
    return response.data
}

export const getOrganizationUsageHistory = async (
  params: GetOrganizationUsageHistoryParams
): Promise<GetOrganizationUsageHistoryResponse> => {
  const queryParams = new URLSearchParams(
    Object.entries(params)
      .filter(([_, value]) => value !== undefined)
      .map(([key, value]) => [key, value.toString()])
  ).toString()
  const response = await apiClient.get(`/organizations/usage-history?${queryParams}`)
  return response.data
}

export const requestEnterprisePlanUpgrade = async (
  params: RequestEnterprisePlanUpgradeParams
) => {
  const response = await apiClient.post(`/organizations/send-enterprise-plan-request-email`, params)
  return response.data
}

